import type { FormsFilters, SubmissionsFilters, TemplatesFilters } from '../types';

export const FORM_KEYS = {
  all: ['forms'] as const,
  byOrg: (orgId: string) => ['forms', orgId] as const,
  list: (orgId: string, filters: FormsFilters, page: number, pageSize: number) =>
    ['forms', orgId, 'list', filters, page, pageSize] as const,
  detail: (orgId: string, formId: string) => ['forms', orgId, 'detail', formId] as const,
  public: (formId: string) => ['forms', 'public', formId] as const,
  accessByToken: (token: string) => ['forms', 'access', token] as const,
  versions: (orgId: string, formId: string) => ['forms', orgId, 'versions', formId] as const,
  sharing: (orgId: string, formId: string) => ['forms', orgId, formId, 'sharing'] as const,
  assignedToMe: (orgId: string, page: number, pageSize: number) =>
    ['forms', orgId, 'assigned-to-me', page, pageSize] as const,
  analytics: (orgId: string, formId: string) => ['forms', orgId, formId, 'analytics'] as const,
};

export const SUBMISSION_KEYS = {
  byForm: (orgId: string, formId: string) => ['forms', orgId, formId, 'submissions'] as const,
  list: (
    orgId: string,
    formId: string,
    filters: SubmissionsFilters,
    page: number,
    pageSize: number,
  ) => ['forms', orgId, formId, 'submissions', 'list', filters, page, pageSize] as const,
  detail: (orgId: string, formId: string, submissionId: string) =>
    ['forms', orgId, formId, 'submissions', 'detail', submissionId] as const,
  stats: (orgId: string, formId: string) =>
    ['forms', orgId, formId, 'submissions', 'stats'] as const,
};

export const TEMPLATE_KEYS = {
  all: ['templates'] as const,
  byOrg: (orgId: string) => ['templates', orgId] as const,
  list: (orgId: string, filters: TemplatesFilters, page: number, pageSize: number) =>
    ['templates', orgId, 'list', filters, page, pageSize] as const,
  detail: (orgId: string, templateId: string) =>
    ['templates', orgId, 'detail', templateId] as const,
};
